import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationServices } from "../services";
import { ConfigurationVariationsCreateInfoPage } from "./configuration-variations-create/configuration-variations-create-info/configuration-variations-create-info";
import { ConfigurationVariationCreateListPage } from './configuration-variations-create/configuration-variation-create-list/configuration-variation-create-list';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationRoomsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-variations',
  templateUrl: 'configuration-variations.html',
})
export class ConfigurationVariationsPage {

  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'price', dir: 'asc' },
    { prop: 'quantity', dir: 'asc' },
    { prop: 'type', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService) {

    this.globals.GAtrackView('Configuration', 'Configuration - Variations - View ', this.globals.restaurant.email, 'View', 'List variations', 'Configuration', '');
  }

  ionViewWillEnter() {
    this.configurationServices.getPagesVariations();
  }

  create() {
    if (this.globals.checkLimitsByLicense('config', 'variations')) {
      this.navCtrl.push(ConfigurationVariationCreateListPage, {
        type: 'all'
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.navCtrl.push(ConfigurationVariationsCreateInfoPage, {
        variation: event.row,
        update_state: true,
        type: event.row.type,
      });
    }
  }

  onSort(event) {
    var variations_array = this.configurationServices.variations_array_filtered;

    switch (event.column.name) {
      case 'name':
        if (event.newValue == 'asc') {
          variations_array.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        } else {
          variations_array.sort((a, b) => b.name.toLowerCase().localeCompare(a.name.toLowerCase()));
        }
        break;
      case 'price':
        if (event.newValue == 'asc') {
          variations_array.sort((a, b) => a.price - b.price);
        } else {
          variations_array.sort((a, b) => b.price - a.price);
        }
        break;
      case 'quantity':
        if (event.newValue == 'asc') {
          variations_array.sort((a, b) => a.quantity.toLowerCase().localeCompare(b.quantity.toLowerCase()));
        } else {
          variations_array.sort((a, b) => b.quantity.toLowerCase().localeCompare(a.quantity.toLowerCase()));
        }
        break;
      case 'type':
        if (event.newValue == 'asc') {
          variations_array.sort((a, b) => a.type.localeCompare(b.type));
        } else {
          variations_array.sort((a, b) => b.type.localeCompare(a.type));
        }
        break;
    }

    this.configurationServices.variations_array_filtered = variations_array;
  }

}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-variations/configuration-variations.ts